import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import './SolutionDetailPages.css';

const sapBanner = process.env.PUBLIC_URL + '/images/hero/hero-banner.jpg';

const relatedSolutions = [
  { title: 'Data & AI Solutions', path: ROUTES.AI_SOLUTIONS },
  { title: 'Blockchain & Web3', path: ROUTES.BLOCKCHAIN_SOLUTIONS },
];

export default function SAPTransformationPage() {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate(ROUTES.HOME);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleExpertCTA = () => {
    navigate(ROUTES.CONTACT);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateRelated = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigateBackToSolutions = () => {
    navigate(ROUTES.SOLUTIONS);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const [solutionData, setSolutionData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/solutions/sap-solutions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setSolutionData(data.solution);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div className="solution-detail-page">
      {/* Banner Section */}
      <section
        className="inner-page-banner"
        style={{ backgroundImage: `url(${sapBanner})` }}
      >
        <div className="inner-page-banner-overlay" />
        <div className="container inner-page-banner-inner">
          <h1 className="inner-page-banner-title">SAP Transformation</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <div className="inner-page-breadcrumb-wrap">
        <div className="container">
          <nav className="inner-page-breadcrumb">
            <button
              type="button"
              className="inner-page-home"
              onClick={handleNavigateHome}
            >
              Home
            </button>
            <span className="inner-page-sep">
              <i className="bi bi-chevron-right" />
            </span>
            <button
              type="button"
              className="inner-page-home"
              onClick={handleNavigateBackToSolutions}
            >
              Solutions
            </button>
            <span className="inner-page-sep">
              <i className="bi bi-chevron-right" />
            </span>
            <span className="inner-page-current">SAP Transformation</span>
          </nav>
        </div>
      </div>

      <div dangerouslySetInnerHTML={{ __html: solutionData.description }} className="solution-detail-page" />

      {/* Related Solutions Section */}
      <section className="solution-related-section">
        <div className="container">
          <div className="solution-related-header">
            <h2 className="section-title">Related Solutions</h2>
          </div>

          <div className="solution-related-grid">
            {relatedSolutions.map((solution, index) => (
              <button
                key={index}
                className="related-solution-card"
                onClick={() => handleNavigateRelated(solution.path)}
              >
                <span className="related-solution-text">
                  {solution.title}
                </span>
                <span className="related-solution-arrow">→</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="solution-detail-cta">
        <div className="container">
          <div className="solution-cta-content">
            <h2 className="solution-cta-title">
              Ready to modernize your SAP environment?
            </h2>

            <button
              className="solution-cta-button"
              onClick={handleExpertCTA}
            >
              Talk to an SAP Expert
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
